export default{
    与我们联系:"お問い合わせ",
    专属客户经理将尽快联系您:"",
    立即参与:"送信",
}